export default [
  {
    id: 1,
    label: "공통사항",
    check: true,
    title: "공통사항",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1 .(현장) 작업 전 안전보건교육은 실시하였는가?(신규, 특별교육/TBM 활동 등)",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. (현장) 작업자에게 작업방법, 순서 등이 전달되었는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. (현장) 작업자는 개인보호구를 착용하고 있는가?(필수: 안전모, 안전화 ,안전그네 등)",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. (현장)유해 ·위험기계기구는 반입 전 안전점검을 받았는가? (점검필증 확인)",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. (현장)작업장통로/계단 등 안전조치는 충분히 확보되어 있는가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. (현장)작업장소의 조도는 충분하게 확보되어 있는가?",
            is_checked: "",
          },
          {
            id: 7,
            label: "7. (현장)해당작업에 대한 위험표지 및 안내간판 등은 설치되어 있는가?",
            is_checked: "",
          },
          {
            id: 8,
            label: "8. (현장)화학물질에 대한 물질안전보건자료 (MSDS)가 비치. 게시되어 있는가?",
            is_checked: "",
          },
          {
            id: 9,
            label: "9. (현장)작업자의 건강상태 이상유무 (고혈압, 고지혈증, 기타 질환)를 확인하였는가?",
            is_checked: "",
          },
          {
            id: 10,
            label: "10. (현장)블랙박스가 비치 되어있고 작동여부를 확인하였는가?",
            is_checked: "",
          },
        ],
      },
    ],
  },
  // {
  //   id: 2,
  //   label: "밀폐공간작업",
  //   check: false,
  //   title: "밀폐공간작업",
  //   list: [
  //     {
  //       headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
  //       headerYesTitle: "적정",
  //       headerNoTitle: "미흡",
  //       headerNATitle: "해당없음",
  //       isTypeMode: false,
  //       isInputMode: false,
  //       list: [
  //         {
  //           id: 1,
  //           label: "1. (서류 )법적 밀폐공간&nbsp;<strong>작업 프로그램은 작성 및 검토 (시공/안전/보건 )되었는가?</strong>",
  //           is_checked: "",
  //         },
  //         {
  //           id: 2,
  //           label: "2. (현장)작업책임자/감시원은 배치되어 있는가?",
  //           is_checked: "",
  //           sign: [
  //             { name: "책임자", value: "" },
  //             { name: "감시원", value: "" },
  //           ],
  //         },
  //         {
  //           id: 3,
  //           label: "3. (현장)작업장소에 환기는 실시하였는가? (첨부 밀폐공간 Check list 환기 방법 참조)",
  //           is_checked: "",
  //         },
  //         {
  //           id: 4,
  //           label: "4. (현장)작업장소에 복합 Gas 농도는 측정(최소 3 Point 이상) 되었는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 5,
  //           label: "5. (현장)작업장소에 밀폐공간 현황판 Log sheet/경고표지는 비치되었는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 6,
  //           label: "6. (현장)비상시 대피용 기구 (구급함, 공기호흡기, 송기마스크 등)를 비치하였는가?",
  //           is_checked: "",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   label: "비계 설치·해체 작업",
  //   check: false,
  //   title: "비계 설치·해체 작업",
  //   list: [
  //     {
  //       headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
  //       headerYesTitle: "적정",
  //       headerNoTitle: "미흡",
  //       headerNATitle: "해당없음",
  //       isTypeMode: false,
  //       isInputMode: false,
  //       list: [
  //         {
  //           id: 1,
  //           label: "1.&nbsp;<strong>작업 안전관리계획서</strong>는 작성 및 검토 되었는가? (계획서 첨부)",
  //           is_checked: "",
  //         },
  //         {
  //           id: 2,
  //           label: "2. 작업장 주위에는 출입방호조치를 하였는가?",
  //           is_checked: "",
  //           sign: [{ name: "통제원 성명", value: "" }],
  //         },
  //         {
  //           id: 3,
  //           label: "3. 부재의 규격 (안전인증 제품) 및 상태는 양호인가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 4,
  //           label: "4. 작업자 추락예방을 위한 안전 난간대, 생명줄 부착설비 등은 적정한가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 5,
  //           label: "5. 작업 시 상하이동동선, 발판 고정 등 설치는 적정한가?",
  //           is_checked: "",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   label: "동바리 설치·해체 작업",
  //   check: false,
  //   title: "동바리 설치·해체 작업",
  //   list: [
  //     {
  //       headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
  //       headerYesTitle: "적정",
  //       headerNoTitle: "미흡",
  //       headerNATitle: "해당없음",
  //       isTypeMode: false,
  //       isInputMode: false,
  //       list: [
  //         {
  //           id: 1,
  //           label: "1.&nbsp;<strong>작업 안전관리계획서</strong>는 작성 및 검토 되었는가? (계획서 첨부)",
  //           is_checked: "",
  //         },
  //         {
  //           id: 2,
  //           label: "2. 작업장의 출입통제 조치는 되었는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 3,
  //           label: "3. 부재의 규격(안전인증 제품) 및 상태는 양호인가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 4,
  //           label: "4. 작업책임자/감시원은 배치되어 있는가?",
  //           is_checked: "",
  //           sign: [
  //             { name: "책임자", value: "" },
  //             { name: "감시원", value: "" },
  //           ],
  //         },
  //         {
  //           id: 5,
  //           label: "5. 작업장의 추락위험 구간(단부, 개구부 등)에 대한 시설물 설치는 적정한가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 6,
  //           label: "6. 해체작업 시 상하이동동선, 발판 고정, 안전망 설치 등은 적정한가?",
  //           is_checked: "",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    id: 5,
    label: "외부 로프 작업",
    check: false,
    title: "외부 로프 작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1. (서류) 작업 전 로프, 달비계, 장비 등 반입기준을 수립하였는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. (현장) 작업책임자/상부 감시원는 배치되었는가?",
            is_checked: "",
            sign: [
              { name: "책임자", value: "" },
              { name: "감시원", value: "" },
            ],
          },
          {
            id: 3,
            label: "3. (현장) 작업 구간에 동시작업 및 간섭사항을 확인하고 작업구간을 통제하였는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. (현장) 인양도구 점검, 모서리 로프 보양 및 로프(8자/2중 매듭/시건 관리) 확인하였는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. (현장) 작업자가 항시 추락 방지대를 올바르게 사용하고 있는가?",
            is_checked: "",
          },
        ],
      },
    ],
  },
  // {
  //   id: 6,
  //   label: "건설용 리프트 설치·연장·해체 작업",
  //   check: false,
  //   title: "건설용 리프트 설치·연장·해체 작업",
  //   list: [
  //     {
  //       headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
  //       headerYesTitle: "적정",
  //       headerNoTitle: "미흡",
  //       headerNATitle: "해당없음",
  //       isTypeMode: false,
  //       isInputMode: false,
  //       list: [
  //         {
  //           id: 1,
  //           label: "1. (서류) 작업계획서는 작성/승인되었는가? (작업계획서 비치)",
  //           is_checked: "",
  //         },
  //         {
  //           id: 2,
  //           label: "2. (현장) 작업책임자/신호수는 배치되었는가?",
  //           is_checked: "",
  //           sign: [
  //             { name: "책임자", value: "" },
  //             { name: "감시원", value: "" },
  //           ],
  //         },
  //         {
  //           id: 3,
  //           label: "3. (현장) 작업반경내 접근금지시설을 설치하였는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 4,
  //           label: "4. (현장) 와이어 로프, 슬링벨트 등 인양도구 안전점검을 실시하였는가?",
  //           is_checked: "",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    id: 7,
    label: "지하층 용접 및 융단 작업",
    check: false,
    title: "지하층 용접 및 융단 작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1. (현장) 작업책임자/화재감시자는 배치되었는가?",
            is_checked: "",
            sign: [
              { name: "책임자", value: "" },
              { name: "감시원", value: "" },
            ],
          },
          {
            id: 2,
            label: "2. (현장) 소화기 및 방화수 등 간이 소화장치는 비치하였는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. (현장) 작업구간에 인화성물질 등 화재 발생 요인은 없는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. (현장) 불티비산방지시설 및 비상통로 유도등은 설치하였는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. (현장) 비상 경보장치는 작동되고 있는가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. (현장) 화재감시인에 확성기, 방염 마스크, 휴대용 손전등은 착용하고 있는가?",
            is_checked: "",
          },
        ],
      },
    ],
  },
  {
    id: 8,
    label: "천정 상부(내부) 작업",
    check: false,
    title: "천정 상부(내부) 작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: '1. (서류) 해당 작업에 대한 "안전작업계획서"는 작성되었는가? (계획서 및 도면 등)',
            is_checked: "",
          },
          {
            id: 2,
            label: "2. (현장) 천정 상부 진입 통로 및 조명은 확보하였는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. (현장) 근로자 출입 Log sheet 는 비치되었는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. (현장) Blind Panel Opening 구간 확인 및 안전시설은 설치하였는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. (서류) 작업책임자 배치 계획 수립 여부?",
            is_checked: "",
            sign: [{ name: "책임자", value: "" }],
          },
          {
            id: 6,
            label: "6. (현장) 작업 구간 하부 출입금지 조치는 하였는가?",
            is_checked: "",
          },
        ],
      },
    ],
  },
  // {
  //   id: 9,
  //   label: "Man Basket 작업",
  //   check: false,
  //   title: "Man Basket 작업",
  //   list: [
  //     {
  //       headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
  //       headerYesTitle: "적정",
  //       headerNoTitle: "미흡",
  //       headerNATitle: "해당없음",
  //       isTypeMode: false,
  //       isInputMode: false,
  //       list: [
  //         {
  //           id: 1,
  //           label: "1. Man-Basket 조립도는 작성되었으며, 안전/시공의 검토 및 승인을 받았는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 2,
  //           label: "2. 러그(Lug) 4개에 대한 비파괴검사가 완료되었는가? (시험 성적서 첨부)",
  //           is_checked: "",
  //         },
  //         {
  //           id: 3,
  //           label: "3. 바닥은 철판을 사용하여 낙하 위험이 없도록 하였는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 4,
  //           label: "4. 샤클(Shackle)의 핀은 고정형 Type이며 안전점검 필증을 부착하였는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 5,
  //           label: "5. 탑승하는 근로자는 안전그네 착용하고 보조 생명줄에 고리를 체결하였는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 6,
  //           label: "6. 작업책임자 및 신호수는 배치되었는가?",
  //           is_checked: "",
  //           sign: [
  //             { name: "책임자", value: "" },
  //             { name: "신호수", value: "" },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: 10,
  //   label: "T/C 설치, 설치·연장·해체 작업",
  //   check: false,
  //   title: "T/C 설치, 설치·연장·해체 작업",
  //   list: [
  //     {
  //       headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
  //       headerYesTitle: "적정",
  //       headerNoTitle: "미흡",
  //       headerNATitle: "해당없음",
  //       isTypeMode: false,
  //       isInputMode: false,
  //       list: [
  //         {
  //           id: 1,
  //           label: "1.&nbsp;<strong>작업 안전관리계획서</strong>는 작성 및 검토 되었는가? (계획서 첨부)",
  //           is_checked: "",
  //         },
  //         {
  //           id: 2,
  //           label: "2. 작업장 주위에는 출입방호조치를 하였는가?",
  //           is_checked: "",
  //           sign: [{ name: "통제원", value: "" }],
  //         },
  //         {
  //           id: 3,
  //           label: "3. 사용 공구(이탈방지 포함) 및 양중기구는 점검을 하였는가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 4,
  //           label: "4. 크레인의 작업계획에 적정한 작업위치, 제원, 전도예방 이행은 양호한가?",
  //           is_checked: "",
  //         },
  //         {
  //           id: 5,
  //           label: "5. 동영상 카메라 작동상태/영상상태 (10m/sec 이상 여부 등)는 양호한가?",
  //           is_checked: "",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    id: 11,
    label: "화기작업",
    check: false,
    title: "화기작업",
    list: [
      {
        headerTitle: "작업전 안전조치 및 확인 점검 사항(이행여부 = V, 해당사항없음 = N/A)",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1. 화재감시자를 적절하게 배치하였는가?",
            is_checked: "",
            sign: [{ name: "통제원", value: "" }],
          },
          {
            id: 2,
            label: "2. 화재감시자는 확성기, 휴대용조명, 방연마스크 등 대피용 방연장비를 휴대하고 있는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 화기작업에 따른 인근 인화성 액체에 대한 방호 및 격리조치(5M 이상)는 적정한가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 화기(용접,용단)작업 구간에는 적정능력 이상의 소화기구를 비치하였는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. 용접불티 비산방지덮개, 용접방화포 등 불꽃, 불티 등 비산방지조치는 적정한가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. 인화성 액체의 증기 또는 용접 흄 등이 남아 있지 않도록 적정한 환기장비등의 조치가 적정한가?",
            is_checked: "",
          },
          {
            id: 7,
            label: "7. 작업자에 대한 화재예방 및 피난교육 등이 적정하게 실시되었는가?",
            is_checked: "",
          },
          {
            id: 8,
            label: "8. 작업자는 적절한 보호구를 착용하고 있는가?",
            is_checked: "",
          },
          {
            id: 9,
            label: "9. 용접, 용단, 가열 및 연마작업 기계, 기구의 점검상태는 양호한가?",
            is_checked: "",
          },
        ],
      },
    ],
  },
  {
    id: 12,
    label: "고소작업",
    check: false,
    title: "고소작업",
    list: [
      {
        headerTitle: "작업 전 점검사항",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1. 작업에 적합한 작업발판(비계, 사다리 등) 사용 하였는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 안전모, 안전대 등 개인보호구 지급 및 착용 하였는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 고소작업 구간 상·하 동시작업을 금지하고 있는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 안전난간, 추락방지망 설치 등 추락 방지 조치를 하였는가?",
            is_checked: "",
          },
          {
            id: 5,
            inputField: true,
            label: "작업 전 조치사항",
            value: "",
          },
        ],
      },
      {
        headerTitle: "작업 후 점검사항",
        headerYesTitle: "적정",
        headerNoTitle: "미흡",
        headerNATitle: "해당없음",
        isTypeMode: false,
        isInputMode: false,
        list: [
          {
            id: 1,
            label: "1. 근로자는 작업완료를 작업책임자(또는 업무담당자)에게 알렸는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 작업책임자(또는 업무담당자)는 작업한 장소를 직접 확인했는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 작업 종료 후 상부 작업 장소 자재 등 낙하 위험이 없는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 작업 후 작업장소에 별다른 이상없이 안전한가?",
            is_checked: "",
          },
          {
            id: 5,
            inputField: true,
            label: "작업 후 조치사항",
            value: "",
          },
        ],
      },
    ],
  },
];
